import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import FormInputField from '../../lib/from-input-field'
import { Form } from '@/components/ui/form'
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import { Separator } from '@/components/ui/separator'
import { Button } from '@/components/ui/button'

export function AddExtraSalaryDialog ({ openExtraSalary, offDialog }) {
  const form = useForm({
    resolver: zodResolver(extraSalarySchema),
    defaultValues: {
      emploayId: '',
      transport: '',
      medical: '',
      mobileAllowance: '',
      bonus : ''
    }
  })

  const addSalary = data => {
    console.log(data)
  }

  return (
    <Dialog open={openExtraSalary} onOpenChange={offDialog}>
      <DialogContent className='sm:max-w-[800px] bg-cblack'>
        <div className='py-5 flex flex-col text-cwhite'>
          <DialogTitle className='text-lg absolute top-4 font-medium text-white'>
            Add New Salary / Payroll
          </DialogTitle>
          <Separator className='mt-4' />
          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(addSalary)}
              className='flex flex-col gap-5 mt-6'
            >
              <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
                <FormInputField
                  name={'emploayId'}
                  style='bg-cblack3'
                  placeholder={'Employee ID / Name'}
                  form={form}
                  type='text'
                  label={'Employee ID / Name'}
                />
              </div>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
                <FormInputField
                  name='transport'
                  style='bg-cblack3'
                  placeholder={'Enter amount'}
                  form={form}
                  type='text'
                  label={'Transport Allowance (DA)'}
                />

                <FormInputField
                  name='medical'
                  placeholder={'Enter amount'}
                  form={form}
                  type='text'
                  style='bg-cblack3'
                  label={'Medical Allowance'}
                />
              </div>

              <div className='grid grid-cols-1 md:grid-cols-2 gap-5'>
                <FormInputField
                  name='mobileAllowance'
                  style='bg-cblack3'
                  placeholder={'Enter amount'}
                  form={form}
                  type='text'
                  label={'Mobile Allowance'}
                />

                <FormInputField
                  name='bonus'
                  placeholder={'Enter amount'}
                  form={form}
                  type='text'
                  style='bg-cblack3'
                  label={'Bonus'}
                />
              </div>

              <Button className='bg-cyellow w-full mt-5 text-cblack font-medium hover:bg-cyellow/90 transition-colors'>
                Confirm
              </Button>
            </form>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
  )
}

const extraSalarySchema = z.object({
  emploayId: z.string().min(1, 'Employee name is required'),
  transport: z.string().min(1, 'Required'),
  medical: z.string().min(1, 'Required'),
  bonus : z.string().min(1, 'Required'),
  mobileAllowance:  z.string().min(1, 'Required')
})
